import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { boxShadow815Grey } from 'approot/shared/styles/borders.style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';

export const ComponentMenuWrapper = styled.div`
  position: relative;
  z-index: 100;
`;

export const ComponentMenuInner = styled.div`
  ${boxShadow815Grey}

  background-color: ${grey1};
  border-radius: ${rem(50)};
  padding: ${rem(spacing4)};
  position: relative;
  z-index: 100000;
`;
